import * as actionTypes from '../actions/actionTypes'
import {updateObject} from "../../utility";

const initialState = {
    token: null,
    email: null,
    redirect: null,
    error: null,
    loading: false,
    company: null,
    permissions: {},
    hasGcp: false,
    gcpOnly: false,
    nextPage: null, //for page following try-login
};

const loginStart = (state, action) => {
    return updateObject(state, {loading: true, error: null, nextPage: null, redirect: null, email: null})
};

const loginSuccess = (state, action) => {
    if (action.hasGcp === undefined) {
        return updateObject(state, {
            token: action.token,
            email: action.email,
            company: action.company,
            permissions: action.permissions,
            error: null,
            loading: false,
        })
    }
    return updateObject(state, {
        token: action.token,
        email: action.email,
        company: action.company,
        permissions: action.permissions,
        hasGcp: action.hasGcp,
        gcpOnly: action.gcpOnly,
        error: null,
        loading: false
    })
};

const tryLoginSuccess = (state, action) => {
    return updateObject(state, {
        email: action.email,
        redirect: action.redirect,
        nextPage: action.ssoLoginOnly ? "/samlRedirect" : "/password",
        error: null,
        loading: false,
    })
}

const loginFail = (state, action) => {
    return updateObject(state, {
        error: action.error,
        email: action.email,
        loading: false,
    })
};

const logoutStart = (state, action) => {
    return updateObject(state, {loading: true, error: null})
};

const logoutSuccess = (state, action) => {
    return updateObject(state, {token: null, email: null})
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.TRY_LOGIN_START:
        case actionTypes.LOGIN_START:
        case actionTypes.SAML_LOGIN_START:
            return loginStart(state, action);
        case actionTypes.TRY_LOGIN_SUCCESS:
            return tryLoginSuccess(state, action);
        case actionTypes.SAML_LOGIN_SUCCESS:
        case actionTypes.LOGIN_SUCCESS:
            return loginSuccess(state, action);
        case actionTypes.LOGIN_FAIL:
        case actionTypes.SAML_LOGIN_FAIL:
            return loginFail(state, action);
        case actionTypes.LOGOUT_START:
            return logoutStart(state, action);
        case actionTypes.LOGOUT_SUCCESS:
            return logoutSuccess(state, action);
        default:
            return state;
    }
};

export default reducer;